
import axios from 'axios'
import { session, keys } from 'store2'

import Keys from '../Keys'
import Config from '../Config'
import Usuarios from './Usuarios'
import Helper from '../components/Sistema/Helper'
import Mensagens from '../Mensagens';

const URLEventos = '/InformacaoGerencial/EventoCongresso?idOperacao=';
const URLCongresso = '/InformacaoGerencial/Congresso?idOperacao=';
const URLInscricao = '/InformacaoGerencial/InscricaoCongresso?idOperacao=';
const URLCongressista = '/InformacaoGerencial/Congressista?idOperacao=';

const headers = {
    'Authentication': `Basic ${Config.API_KEY}`
}
class Eventos {


    nuRegistros = 50;


    handleErro(erro) {
        return new Promise((resolve, reject) => {

            var msg = 'Ocorreu um erro ao recuperar as informações'

            if (Helper.isDevEnvironment()) {
                msg += `******** ERRO: *******${erro}`
            }
            resolve({
                sucesso: false,
                Mensagem: msg,
                data: null
            })
        })
    }

    handleSucesso(response) {
        var data = response.data.data
        let resposta = { sucesso: false, Mensagem: 'Ocorreu um erro ao submeter as informações' }

        if (data.Regra) {
            resposta.Mensagem = data.Regra.deRegra
            resposta.data = data
        }
        else {

            resposta.sucesso = true
            resposta.Mensagem = ''
            resposta.data = data
        }
        return resposta
    }

    setIdCongresso(id) {
        session.remove(Keys.ID_CONGRESSO)
        session.add(Keys.ID_CONGRESSO, id)

    }
    hasIdCongresso() {
        return session.has(Keys.ID_CONGRESSO)
    }
    getIdCongresso() {
        return session.get(Keys.ID_CONGRESSO)
    }

    getCongressoByCodigo(codigo) {

        let url = `${Config.API_URL}${URLCongresso}1&idCongressoEncrypted=${codigo}`

        return axios.get(url, { headers: headers })
            .then(response => {

                return this.handleSucesso(response);
            })
            .catch(this.handleErro)
    }

    getCongresso() {


        let url = `${Config.API_URL}${URLCongresso}7&idCongressoEncrypted=${this.getIdCongresso()}`

        return axios.get(url, { headers: headers })
            .then(response => {

                return this.handleSucesso(response);
            })
            .catch(this.handleErro)
    }

    getEventoCongresso(token){
        let url = `${Config.API_URL}${URLEventos}20&idEventoCongressoEncrypted=${token}&includeProperties=Congresso`
        
        return axios.get(url, { headers: headers })
            .then(response => {

                return this.handleSucesso(response);
            })
            .catch(this.handleErro)
    }
    
    gettipologin (tipoLogin)  {
        switch (tipoLogin) {
            case '1':
            case 1:
                return 'Aluno';
            case '2':
            case 2:
                return 'funcionário';
            case '3':
            case 3:
                return 'Público Externo';
          default:
            return 'Valor desconhecido';
        }
      }

      getIdEventoCongresso(idEventoCongressoEncrypted){
        let url = `${Config.API_URL}${URLInscricao}25&idEventoCongressoEncrypted=${idEventoCongressoEncrypted}`

        return axios.get(url, { headers: headers })
            .then(response => { 
                return response.data.data })
            .catch(this.handleErro)
      }

      jaMarcouPresenca(idCongressista, idEventoCongresso){
        let url = `${Config.API_URL}${URLInscricao}24&idCongressista=${idCongressista}&idEventoCongresso=${idEventoCongresso}&`
        
        return axios.get(url, { headers: headers })
            .then(response => { 
                return response.data.data 
            })
            .catch(this.handleErro)
      }

    realizarParticipacaoEvento(congressista, tipoLogin, idEventoCongresso, userLogin){
        let url = `${Config.API_URL}${URLInscricao}`
        let usuario = Usuarios.isAuthenticated() ? Usuarios.getCurrentUser(): null
        
        let dadosInscricao = {
            idOperacao: 23,
            idCongressoEncrypted: this.getIdCongresso(),
            idEventoCongresso:idEventoCongresso,
            presencaParticipanteEvento: [
                {
                    nomeCompleto: congressista.nmCongressista,
                    email: congressista.edEmail,
                    telefone: congressista.nuTelefone,
                    tipoParticipante: this.gettipologin(tipoLogin),
                    cpf: congressista.coIdentificador,
                    drt: tipoLogin == '2' ? userLogin : '',
                    ra: tipoLogin == '1' ? userLogin : ''
                },
            ],
            icSiteEventos: true,
            idCongressista: congressista.idCongressista,
            IdUsuarioAcao: usuario.idUsuario
        }
        
        return axios.post(url, dadosInscricao, { headers: headers })
            .then(response => {

                return response.data.data;
            })
            .catch(this.handleErro)
    }


    getEventosCongresso(page, count, order) {

        let user = Usuarios.getCurrentUser();

        let url = `${Config.API_URL}${URLEventos}15&idCongressoEncrypted=${this.getIdCongresso()}&nuPagina=${page}&nuRegistros=${count}
            &idCongressistaEncrypted=${Usuarios.isAuthenticated() && user.token ? user.token : ''}&icVerificaChoqueHorario=${Usuarios.isAuthenticated()}&deOrdenacao=${order}`


        return axios.get(url, { headers: headers })
            .then(response => { return response.data.data.$values })
            .catch(this.handleErro)

    }

    getCongressista() {

        let url = `${Config.API_URL}${URLCongressista}9&tokenCongressista=${Usuarios.getCurrentUser().token}`

        return axios.get(url, { headers: headers })
            .then(response => {                
                return this.handleSucesso(response)
            })
            .catch(this.handleErro)
    }

    getCongressistaLogado(idCongressista) {

        let url = `${Config.API_URL}${URLCongressista}1&idCongressista=${idCongressista}&includeProperties=Funcionario,Aluno`

        return axios.get(url, { headers: headers })
            .then(response => {                
                return this.handleSucesso(response)
            })
            .catch(this.handleErro)
    }

    realizarInscricaoEvento(idEvento) {
        let url = `${Config.API_URL}${URLInscricao}`

        let token = Usuarios.getCurrentUser() ? Usuarios.getCurrentUser().token : ''
        let idUsuario = Usuarios.isAuthenticated() ? Usuarios.getCurrentUser().idUsuario : ''

        let dadosInscricao = {
            idOperacao: 16,
            idCongressoEncrypted: this.getIdCongresso(),
            inscricao: {
                idEventoCongresso: idEvento,
                icDisponibilidadeVaga: true,
                icEventos:true,
                icVerificaChoque: true,
                tokenCongressista: token
            },
            IdUsuarioAcao: idUsuario
        }

        return axios.post(url, dadosInscricao, { headers: headers })
            .then(response => {

                let data = response.data.data

                let resposta = { sucesso: false, Mensagem: 'Ocorreu um erro ao submeter as informações' }

                if (data.Regra === null) {
                    resposta.sucesso = true
                    resposta.Mensagem = ''
                    resposta.data = data
                }
                else {
                    resposta.Mensagem = data.Regra.deRegra
                    resposta.data = data
                }
                return resposta
            })
            .catch(this.handleErro)
    }

    handleInscricao(idEvento, username, password, option, icRealizaInscricao, participante) {

        let url = `${Config.API_URL}${URLInscricao}`

        let token = Usuarios.getCurrentUser() ? Usuarios.getCurrentUser().token : ''
        let idUsuario = Usuarios.isAuthenticated() ? Usuarios.getCurrentUser().idUsuario : ''

        let dadosInscricao = {
            idOperacao: 16,
            idCongressoEncrypted: this.getIdCongresso(),
            inscricao: {
                coAcesso: username,
                coSenha: password,
                idEventoCongresso: idEvento,
                opcaoLogin: option,
                icDisponibilidadeVaga: true,
                icEventos:true,
                icVerificaChoque: true,
                icRealizaInscricao: icRealizaInscricao,
                tokenCongressista: token,
                /*--cadastro de congressista-- */
                nmCongressista: participante ? participante.nmParticipante : '',
                edEmail: participante ? participante.edEmail : '',
                nuCPF: participante ? participante.nuCPF : '',
                nuDDD: participante ? participante.nuDDD : '',
                nuTelefone: participante ? participante.nuTelefone : '',
                coIdentificador: participante ? participante.nuCPF : ''
            },
            IdUsuarioAcao: idUsuario
        }

        return axios.post(url, dadosInscricao, { headers: headers })
            .then(async response => {                
                let data = response.data.data
                
                if(response != null
                    && response.data != null
                    && response.data.data != null
                    && (response.data.data.Regra == null
                        || response.data.data.Regra.deRegra == null)
                )
                {
                    let identificador = "";
                    
                    var congressista = await this.getCongressistaLogado(response.data.data.idCongressista);
                    
                    if(congressista.sucesso == true){
                        if(option === 1) {
                            identificador = congressista.data.nuRa;
                        }

                        else if(option === 2) {
                            identificador = congressista.data.nuDRT;
                        }

                        else  {
                            identificador = congressista.data.nuCPF;
                        }
                        
                    }

                    let novoData = {
                        ...data,
                        iddkk:identificador,
                        optLogin: option
                    }
                    
                    Usuarios.setCurrentUser(novoData)
                }

                let resposta = { sucesso: false, Mensagem: 'Ocorreu um erro ao submeter as informações', data: null }
                
                    if (data.Regra === null) {
                        resposta.sucesso = true
                        resposta.Mensagem = ''
                        resposta.data = data
                    }
                    else if (option === 3) {
                        resposta.Mensagem = data.Regra.deRegra
                        resposta.data = { icCadastro: true, nmParticipante: username, edEmail: password }

                        if (participante) {
                            resposta.data = participante
                            resposta.data.nmParticipante = participante.nuCPF
                        }
                    }
                    else {
                        resposta.Mensagem = data.Regra.deRegra
                        resposta.data = data
                    }
                    return resposta
                // })
            })
            .catch(this.handleErro)
    }

    getInscricoesCongressistaPresenca() {
        let idCongressista = Usuarios.getCurrentUser() ? Usuarios.getCurrentUser().token : '';

        let url = `${Config.API_URL}${URLInscricao}11&idCongressistaEncrypted=${idCongressista}&nuPagina=0&nuRegistros=0`


        return axios.get(url, { headers: headers })
            .then(response => {

                var data = response.data.data.$values
                let resposta = { sucesso: false, Mensagem: 'Ocorreu um erro ao recuperar as informações' }

                if (data || data.length > 0) {
                    resposta.sucesso = true
                    resposta.Mensagem = ''
                    resposta.data = data
                }
                else {
                    resposta.sucesso = false
                    resposta.data = data
                }
                return resposta
            })
            .catch(this.handleErro)
    }

    getEventosNPS() {

        return this.getInscricoesCongressista().then(result => {

            let inscricaoNPS = [];
            if (result.sucesso) {
                inscricaoNPS = result.data.filter((item) => {
                    return (item.icMarcadaPresenca && item.nuEscalaNPS === '')
                })
            }

            return new Promise((resolve, reject) => {

                resolve({
                    sucesso: true,
                    Mensagem: '',
                    data: {
                        nuEventosNaoAvaliados: inscricaoNPS.length,
                        eventos: result.data
                    }
                })
            })
        })
            .catch(this.handleErro)


    }

    getInscricoesCongressista() {
        let idCongressista = Usuarios.getCurrentUser() ? Usuarios.getCurrentUser().token : '';

        let url = `${Config.API_URL}${URLInscricao}19&idCongressistaEncrypted=${idCongressista}&nuPagina=0&nuRegistros=0`


        return axios.get(url, { headers: headers })
            .then(response => {

                var data = response.data.data.$values
                let resposta = { sucesso: false, Mensagem: 'Ocorreu um erro ao recuperar as informações' }

                if (data || data.length > 0) {
                    resposta.sucesso = true
                    resposta.Mensagem = ''
                    resposta.data = data
                }
                else {
                    resposta.sucesso = false
                    resposta.data = data
                }
                return resposta
            })
            .catch(this.handleErro)
    }

    setEventoNPS(idInscricao, nota) {

        let url = `${Config.API_URL}${URLInscricao}`

        var data = {
            idOperacao: 14,
            inscricoes: [{ idInscricaoCongresso: idInscricao, nuEscalaNPS: nota }]
        }

        return axios.post(url, data, { headers: headers })
            .then(response => {
                let resposta = { sucesso: true, Mensagem: 'Avaliação realizada com sucesso!' }
                return resposta
            })
            .catch(this.handleErro)

    }

    getCertificado() {

        if (session.has(Keys.URL_CERTIFICADO)) {
            return this.baixarArquivo(Keys.URL_CERTIFICADO, 'certificado')
        }
        let urlRetorio = `${Config.API_URL}${URLCongressista}6&tokenCongressista=${Usuarios.getCurrentUser().token}`

        return axios.get(urlRetorio, { headers: headers })
            .then(r => {
                session.add(keys.URL_CERTIFICADO, r.data.data.url)
                return this.baixarArquivo(r.data.data.url, 'certificado')
            })
    }

    getComprovante() {

        if (session.has(Keys.URL_COMPROVANTE)) {
            return this.baixarArquivo(Keys.URL_COMPROVANTE, 'comprovante')
        }
        let urlRetorio = `${Config.API_URL}${URLCongressista}8&tokenCongressista=${Usuarios.getCurrentUser().token}`

        return axios.get(urlRetorio, { headers: headers })
            .then(r => { return this.baixarArquivo(r.data.data.url, 'comprovante') })
    }

    getCracha() {

        if (session.has(Keys.URL_CRACHA)) {
            return this.baixarArquivo(Keys.URL_CRACHA, 'cracha')
        }
        let urlRetorio = `${Config.API_URL}${URLCongressista}7&tokenCongressista=${Usuarios.getCurrentUser().token}`

        return axios.get(urlRetorio, { headers: headers })
            .then(r => { return this.baixarArquivo(r.data.data.url, 'cracha') })
    }

    baixarArquivo(url, nmCertificado) {

        let urlDownload = `${Config.API_URL}/Sistema/Report?idOperacao=1&url=${url}`

        return axios({
            url: urlDownload,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {

            urlDownload = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = urlDownload;
            link.setAttribute('download', `${nmCertificado}.pdf`);
            document.body.appendChild(link);
            link.click();

            return {
                sucesso: true,
                Mensagem: 'O seu download começou.'
            }
        })
            .catch(this.handleErro)
    }

    excluirInscricao(idInscricao) {

        let url = `${Config.API_URL}${URLInscricao}3&idInscricaoCongresso=${idInscricao}`

        return axios.delete(url, { headers: headers })
            .then(response => {
                let resposta = { sucesso: true, Mensagem: Mensagens.m59 }
                return resposta
            })
            .catch(this.handleErro)


    }
}
const AppEventos = new Eventos()

export default AppEventos



// WEBPACK FOOTER //
// ./src/services/Eventos.js